import { SettingsAutocheckEnum, SettingsRequestTypeEnum } from '../types/settingsEnum'

export const SettingsAutoCheckConfig = {
  [SettingsAutocheckEnum.EOB]: {
    title: 'Request Explanation of Benefits',
    tooltip: '',
    item: [
      {
        title: 'Always request EOBs',
        value: SettingsRequestTypeEnum.always,
        name: SettingsAutocheckEnum.EOB,
        tooltip: '',
      },
      {
        title: 'Ask me every time',
        value: SettingsRequestTypeEnum.everytime,
        name: SettingsAutocheckEnum.EOB,
        tooltip: '',
      },
    ],
  },
  [SettingsAutocheckEnum.AutoCheckCalls]: {
    title: 'Repeat calls on previously Autochecked Claims',
    tooltip:
      'Elect whether or not to run AutoCheck again on re-uploaded claims that were or are actively being called on in another AutoCheck batch./n Claim’s Unique IDs are used to determine if previously AutoChecked.',
    item: [
      {
        title: 'No, do not repeat calls (Default)',
        value: SettingsRequestTypeEnum.always,
        name: SettingsAutocheckEnum.AutoCheckCalls,
        tooltip: '',
      },
      {
        title: 'Ask me every time',
        value: SettingsRequestTypeEnum.everytime,
        name: SettingsAutocheckEnum.AutoCheckCalls,
        tooltip: '',
      },
    ],
  },
  [SettingsAutocheckEnum.AutoCheck]: {
    title: 'Bypass AutoCheck when uploading claim files',
    tooltip: '',
    item: [
      {
        title: 'Never (Default)',
        value: SettingsRequestTypeEnum.always,
        name: SettingsAutocheckEnum.AutoCheck,
        tooltip: 'Queues each claim file for AutoCheck batch processing once it is uploaded/approved',
      },
      {
        title: 'Ask me every time',
        value: SettingsRequestTypeEnum.everytime,
        name: SettingsAutocheckEnum.AutoCheck,
        tooltip:
          'Replaces the “Upload File” button with a menu asking which upload type for each file - either for AutoCheck Batch Processing or Claim List Import only',
      },
    ],
  },
}
